/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';

const options = {
  soldiers: 'Солдаты',
  sailors: 'Матросы',
  sergeants: 'Cержанты',
  ensigns: 'Прапорщики',
  midshipmans: 'Мичманы',
};

const MilitaryContingentDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={options} />;
};

export default MilitaryContingentDropdown;
